import { pm2ConfigStore } from '@pm2/store';
import { makeTanstackQuery } from '@provider/tanstack';
import { useUserIdentityState } from '@provider/user-identity';
import { configRefs, DAYS_TO_MS } from '@utils/constants';
import { getLastLocationRequest } from './get-last-location.request.js';

const getLastLocationDescriptorQuery = makeTanstackQuery({
  defaultQueryConfig: {
    staleTime: 1 * DAYS_TO_MS,
    gcTime: 21 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  },
  queryKey: input => ["user-area/location/get-last", configRefs.env.app.dangerouslyAssertSyncValue(), input.portalId, input.user?.id],
  queryFn: async input => {
    if (!input.user) {
      return null;
    }
    const res = await getLastLocationRequest(input.configStore.getState().config, input.user);
    return res;
  },
  useQueryInput(queryFactory) {
    const user = useUserIdentityState(state => state.user);
    const configStore = pm2ConfigStore.useStore();
    const portalId = configStore.useSelector(state => state.config.id);
    return queryFactory({
      user,
      configStore,
      portalId
    });
  }
});

export { getLastLocationDescriptorQuery };
//# sourceMappingURL=get-last-location.query.js.map
